module.exports = "pegasus_template/assets/graycircle-twitter.png";